import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import CheckboxIcon from "./icons/CheckboxIcon";
import CheckedIcon from "./icons/CheckedIcon";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	container: {
		position: "relative",
		cursor: "pointer",
	},
	containerDisabled: {
		cursor: "not-allowed",
	},
	fullWidth: {
		width: "100%",
	},
	checkbox: {
		cursor: "inherit",
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		opacity: 0,
		width: "100%",
		height: "100%",
		margin: 0,
		padding: 0,
	},
	flexRow: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "flex-start",
	},
	icon: {
		width: 18,
		height: 18,
		margin: 3,
		fill: colors.textDarkGrey2,
		minWidth: 18,
	},
	iconChecked: {
		fill: colors.docketLightishBlue,
	},
	iconDisabled: {
		fill: colors.transparentBlack8,
	},
	label: {
		color: colors.textDarkGrey3,
		fontSize: 16,
		lineHeight: "24px",
		flex: "1 0 auto",
		marginLeft: 16,
	},
	labelDisabled: {
		color: colors.transparentBlack8,
	},
});

export default class SimpleCheckbox extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		aStylesIcon: docketPropTypes.aphroditeStyles,
		aStylesIconChecked: docketPropTypes.aphroditeStyles,
		aStylesIconContainer: docketPropTypes.aphroditeStyles,
		aStylesLabel: docketPropTypes.aphroditeStyles,
		checked: PropTypes.bool,
		disabled: PropTypes.bool.isRequired,
		fullWidth: PropTypes.bool,
		id: PropTypes.string,
		label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
		onCheck: PropTypes.func,
	};

	static defaultProps = {
		disabled: false,
	};

	state = {
		checked: !!this.props.checked,
	};

	componentDidUpdate() {
		if (this.props.checked !== this.state.checked) {
			this.setState({ checked: this.props.checked });
		}
	}

	_handleCheck = e => {
		if (this.props.onCheck) {
			this.props.onCheck(e, !this.state.checked);
		}

		this.setState(prevState => ({ checked: !prevState.checked }));
	};

	_renderLabel = () => {
		if (this.props.id) {
			return (
				<label
					className={css(
						appStyles.baseFont,
						styles.label,
						this.props.aStylesLabel,
						this.props.disabled ? styles.labelDisabled : null,
					)}
					htmlFor={this.props.id}
				>
					{this.props.label}
				</label>
			);
		}
		return (
			<div
				className={css(
					appStyles.baseFont,
					styles.label,
					this.props.aStylesLabel,
					this.props.disabled ? styles.labelDisabled : null,
				)}
			>
				{this.props.label}
			</div>
		);
	};

	render() {
		return (
			<div
				className={css(
					styles.container,
					this.props.fullWidth ? styles.fullWidth : null,
					this.props.disabled ? styles.containerDisabled : null,
					this.props.aStyles,
				)}
			>
				<input
					className={css(styles.checkbox)}
					disabled={this.props.disabled}
					onChange={this._handleCheck}
					type="checkbox"
					value={this.state.checked}
					id={this.props.id}
				/>

				<div className={css(styles.flexRow, this.props.aStylesIconContainer)}>
					{this.state.checked ? (
						<CheckedIcon
							className={css(
								styles.icon,
								styles.iconChecked,
								this.props.aStylesIcon,
								this.props.aStylesIconChecked,
								this.props.disabled ? styles.iconDisabled : null,
							)}
						/>
					) : (
						<CheckboxIcon
							className={css(
								styles.icon,
								this.props.aStylesIcon,
								this.props.disabled ? styles.iconDisabled : null,
							)}
						/>
					)}

					{this.props.label ? this._renderLabel() : null}
				</div>
			</div>
		);
	}
}
